import API from 'api'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  initialzeInclusionsFormValues,
  isBelongsTo,
} from '../../account/booking-details/helpers'
import { convertCurrency } from '../../helpers'
import useCurrentShop from './useCurrentShop'
import useTrip from './useTrip'
import get from 'lodash/get'
import { setInclusions } from '../../../actions/resort-checkout-actions'
import { showLoader } from '../../../actions/main-actions'
import dayjs from 'dayjs'

export default function useLaInclusions() {
  const dispatch = useDispatch()
  const { selectedTrip } = useTrip()
  const { shopInfo } = useCurrentShop()
  const { currency } = shopInfo
  const { guestsSplitting, totalPrice, roomParams } = useSelector(
    ({ guestsSplitting, totalPrice, roomParams }) => ({
      guestsSplitting,
      totalPrice,
      roomParams,
    }),
  )
  const [inclusionsData, setInclusionsData] = useState({})

  useEffect(() => {
    if(guestsSplitting) {
      getInclusions()
    }
  }, [guestsSplitting])

  const saveInclusions = (inclusions) => {
    dispatch(setInclusions(inclusions))
  }

  const options = {
    date_after: dayjs(selectedTrip.startDate).format('YYYY-MM-DD'),
    date_before: dayjs(selectedTrip.endDate).format('YYYY-MM-DD'),
  }

  const getInclusions = () => {
    dispatch(showLoader(true))
    Promise.all([
      API('booking/insurances').get(),
      API(`booking/liveaboard/${selectedTrip.itinerary.slug}/inclusions/`).get(
        options,
      ),
    ])
      .then(([insurances, inclusions]) => {
        const insurance = get(insurances, '[0]', {})
        const isFreeInsurance =
          convertCurrency(
            totalPrice / roomParams.totalGuests,
            currency,
            insurance.limitPriceCurrency,
          ) > Number(insurance.limitPrice)

        const insuranceItem = isFreeInsurance
          ? [
            {
              ...insurance,
              pricingId: get(insurance, 'prices[0].id'),
              price: get(insurance, 'prices[0].priceGross'),
              currency: get(insurance, 'prices[0].priceCurrency'),
              maxLimit: roomParams.totalGuests,
              source: get(insurance, 'prices[0].source'),
              isInsurance: true,
            },
          ]
          : []
        const diverCoursesList = []
        const nonDiverCoursesList = []
        inclusions.forEach((incl) => {
          if(
            isBelongsTo(incl.belongsTo, 'LiveaboardCourses') &&
            incl.pricingId &&
            (incl.priceGross > 0 || incl.extraValue)
          ) {
            if(incl.isNondiverInclusion) {
              nonDiverCoursesList.push(incl)
            } else {
              diverCoursesList.push(incl)
            }
          }
        })
        setInclusionsData({
          dateFrom: selectedTrip.startDate,
          dateTo: selectedTrip.endDate,
          divesAmount: 10,
          diverCoursesList,
          nonDiverCoursesList,
          insurances: insuranceItem,
          ...initialzeInclusionsFormValues({
            shopKind: 10,
            inclusions,
            diverCoursesList,
            nonDiverCoursesList,
            totalGuests: roomParams.totalGuests,
            duration: selectedTrip.duration,
            diversNumber: roomParams.divers,
            maxDives: selectedTrip?.itinerary?.totalNumberOfDives,
            roomParams,
            nonDiversNumber: roomParams.nonDivers,
            studentsNumber: 0,
            addMandatory: true,
            insuranceItem,
          }),
        })
      })
      .finally(() => {
        dispatch(showLoader(false))
      })
  }
  return {
    saveInclusions,
    inclusionsData,
  }
}
